export default __webpack_public_path__ + "static/media/error-icon.4113b260.svg";